import React from 'react';

import {
    Dialog, DialogActions,DialogTitle,
    DialogContent, DialogContentText, makeStyles
} from '@material-ui/core';

import KenColors from '../../../Utils/themes/KenColors';
import KenButton from "../../../global_components/KenButton/index"

import { useTranslation } from 'react-i18next';
import warring from "../../../Assets/icons/warning.svg"


const useStyles = makeStyles((theme) => ({
    eventTitle: {
        background: KenColors.eventTitleBackgroundColor,
        padding: 10,
        fontWeight: 600,
        color: KenColors.eventTitleColor
    }

}));

const ConformationModal = (props) => {
    const { t } = useTranslation();




    const handleClose = () => {
        props.setConfirmationOpen(false);
    };



    return (
        <Dialog open={props.confirmOpen} onClose={handleClose} fullWidth={true} aria-labelledby="form-dialog-title">
            <DialogTitle id="alert-dialog-title">
                {t("labels:Confirmation")}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    
                        <img className="warring_imag" src={warring} /> {t("messages:Are_you_sure_you_would_like_to_delete")} <strong>{props.title}</strong> ?

                </DialogContentText>



            </DialogContent>
            <DialogActions className="mr-2">
                <KenButton variant="outlined" onClick={handleClose} >
                    {t("labels:cancel")}
                </KenButton>
                <KenButton variant="contained" onClick={() => {props.clickConfirmation(true)}} color="primary">
                    {t("labels:Delete")}
                </KenButton>

            </DialogActions>



        </Dialog>
    );
}

export default ConformationModal;